import { Center, Stack, Text, Title } from '@mantine/core'
import { IconTool } from '@tabler/icons-react'
import { useEffect, useState } from 'react'

interface MaintenancePageProps {
  message: string | null
  until: string | null
}

function CountdownTimer({ until }: { until: string }) {
  const [remaining, setRemaining] = useState('')

  useEffect(() => {
    function calc() {
      const diff = new Date(until).getTime() - Date.now()
      if (diff <= 0) {
        setRemaining('')
        return
      }
      const hours = Math.floor(diff / 3_600_000)
      const minutes = Math.floor((diff % 3_600_000) / 60_000)
      const seconds = Math.floor((diff % 60_000) / 1000)

      const parts: string[] = []
      if (hours > 0) parts.push(`${hours} jam`)
      if (minutes > 0) parts.push(`${minutes} menit`)
      parts.push(`${seconds} detik`)
      setRemaining(parts.join(' '))
    }

    calc()
    const interval = setInterval(calc, 1000)
    return () => clearInterval(interval)
  }, [until])

  if (!remaining) return null

  return (
    <Text size="lg" c="dimmed" ta="center">
      Estimasi selesai dalam {remaining}
    </Text>
  )
}

export function MaintenancePage({ message, until }: MaintenancePageProps) {
  return (
    <Center h="100vh" px="md" style={{ background: 'var(--mantine-color-body)' }}>
      <Stack align="center" gap="lg" maw={500}>
        <div
          style={{
            width: 80,
            height: 80,
            borderRadius: '50%',
            background: 'var(--mantine-color-yellow-light)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <IconTool size={40} color="var(--mantine-color-yellow-6)" />
        </div>

        <Title order={2} ta="center">
          Sedang Dalam Pemeliharaan
        </Title>

        <Text size="md" c="dimmed" ta="center">
          {message || 'Sistem sedang dalam pemeliharaan terjadwal. Silakan coba beberapa saat lagi.'}
        </Text>

        {until && <CountdownTimer until={until} />}

        {until && (
          <Text size="sm" c="dimmed" ta="center">
            Dijadwalkan selesai:{' '}
            {new Date(until).toLocaleDateString('id-ID', {
              weekday: 'long',
              day: 'numeric',
              month: 'long',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
            })}
          </Text>
        )}
      </Stack>
    </Center>
  )
}
